import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error(
        '❌ Faltan las credenciales de Supabase en las variables de entorno.\n' +
        '💡 Crea un archivo .env en la carpeta frontend/ con:\n' +
        '   REACT_APP_SUPABASE_URL=tu_url_de_supabase\n' +
        '   REACT_APP_SUPABASE_ANON_KEY=tu_anon_key_de_supabase'
    );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'consoliday-auth',
    },
});

